export default __webpack_public_path__ + "static/media/sponsor-icon-active.c628a425.webp";